import { useQuery } from '@tanstack/react-query';
import apiService from '../services/api';

/**
 * 🟢 [P2] 公共 React Query 读取 hooks
 *
 * 统一放置只读数据的查询逻辑，页面用这些 hook 取代
 * useEffect + useState 手动请求，从而获得：
 *  - 切回页面时命中缓存、无闪烁
 *  - staleTime 内不重复请求，降低 Firestore 读取
 *  - 自动的 loading / error / 后台刷新状态
 *
 * queryKey 命名约定：[资源名, ...参数]，方便按前缀失效。
 */

// 商店商品（按积分升序）
export const useShopItems = () =>
  useQuery({
    queryKey: ['shopItems'],
    queryFn: async () => {
      const data = await apiService.getShopItems();
      const items = data.items || [];
      return [...items].sort((a, b) => a.price - b.price);
    },
  });

// 课程列表
export const useLessons = (params = {}) =>
  useQuery({
    queryKey: ['lessons', params],
    queryFn: async () => {
      const data = await apiService.getLessons(params);
      return data.lessons || data || [];
    },
  });

// 学习进度（options 可传 { enabled } 等按角色控制是否请求）
export const useProgress = (options = {}) =>
  useQuery({
    queryKey: ['progress'],
    queryFn: () => apiService.getProgress(),
    ...options,
  });

// 作业列表（教师/学生通用）
export const useAssignments = (params = {}) =>
  useQuery({
    queryKey: ['assignments', params],
    queryFn: async () => {
      const data = await apiService.getAssignments(params);
      return data.assignments || data || [];
    },
  });

// 系统徽章
export const useSystemBadges = (options = {}) =>
  useQuery({
    queryKey: ['badges', 'system'],
    queryFn: async () => {
      const data = await apiService.getSystemBadges();
      return data.badges || data || [];
    },
    ...options,
  });

// 当前用户已获得的徽章
export const useUserBadges = () =>
  useQuery({
    queryKey: ['badges', 'user'],
    queryFn: async () => {
      const data = await apiService.getUserBadges();
      return data.badges || data || [];
    },
  });
